import { useAuthenticationStore } from "@/stores/authentication"
import { useEstablishmentStore } from "@/stores/establishment"
import { getAccessPlanCode } from "@/utils/contract"

/**
 * Aligné avec hasKnowledgeBaseMenuItem dans Menu.vue :
 * - DEMO : accès portail démo (setup site web)
 * - Sinon : mode expert, initialisation en cours, ou base déjà initialisée
 */
export default () => {
  const auth = useAuthenticationStore()
  const establishmentStore = useEstablishmentStore()
  const establishment = establishmentStore.currentEstablishment

  if (getAccessPlanCode(establishment) === "DEMO") {
    return { success: true }
  }

  const aiMode = auth.user?.account?.ai_mode
  const initStatus = establishment?.knowledge_base_initialization?.status
  const initInProgress = initStatus === "pending" || initStatus === "running"

  if (aiMode === "expert" || establishment?.knowledge_base_initialized || initInProgress) {
    return { success: true }
  }

  return { success: false, path: "/error" }
}
